import Alpine from "alpinejs";

const COMPANY_LINE_BREAKPOINT = "(min-width: 768px)";

export const companyLineInview = () => {
  Alpine.data("companyLineInview", () => ({
    isVisible: false,
    targetWidth: "var(--grid-w-1)",
    observer: null as IntersectionObserver | null,
    mediaQuery: null as MediaQueryList | null,

    init() {
      this.mediaQuery = window.matchMedia(COMPANY_LINE_BREAKPOINT);
      this.updateTargetWidth();

      const handleMediaQueryChange = () => {
        this.updateTargetWidth();
      };

      this.mediaQuery.addEventListener("change", handleMediaQueryChange);

      this.observer = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;

          if (!entry?.isIntersecting) {
            return;
          }

          this.isVisible = true;
          this.destroyObserver();
        },
        {
          threshold: 0.35,
        }
      );

      this.observer.observe(this.$root);

      this.$el.addEventListener(
        "alpine:destroy",
        () => {
          this.destroyObserver();
          this.mediaQuery?.removeEventListener("change", handleMediaQueryChange);
        },
        { once: true }
      );
    },

    updateTargetWidth() {
      this.targetWidth = this.mediaQuery?.matches ? "var(--grid-w-2)" : "var(--grid-w-1)";
    },

    destroyObserver() {
      this.observer?.disconnect();
      this.observer = null;
    },
  }));
};
